import React from 'react'
import { DATA_TYPES, DataType } from '../../constants'
import { useTranslate } from '../../hooks/useTranslate'

interface DataTypeSelectorProps {
    value: DataType
    onChange: (value: DataType) => void
    className?: string
}

const DataTypeSelector: React.FC<DataTypeSelectorProps> = ({
    value,
    onChange,
    className = ''
}) => {
    const { t } = useTranslate();
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value as DataType)}
            title={value}
            className={`block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-brand-500 focus:border-brand-500 bg-white text-gray-900 shadow-sm transition-all duration-200 cursor-pointer appearance-none notranslate ${className}`}
            style={{
                WebkitAppearance: 'menulist',
                maxWidth: '26ch',
                minWidth: '14ch'
            }}
        >
            {/* Defensive placeholder (hidden once selection present) */}
            {!value && (
                <option value="" disabled className="text-gray-500">
                    {t('Select type')}
                </option>
            )}
            {DATA_TYPES.map((dataType) => (
                <option
                    key={dataType}
                    value={dataType}
                    className="text-gray-900 bg-white"
                >
                    {dataType}
                </option>
            ))}
        </select>
    )
}

export default DataTypeSelector